import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import VueStorage from 'vue-ls'
import filters from '@/filters'
import 'ant-design-vue/dist/antd.less'
import './styles/class.less'
import './styles/global.less'
import './styles/custom.scss'
import quillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core'
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart, LineChart, PictorialBarChart } from 'echarts/charts'
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  DataZoomComponent,
  LegendComponent
} from 'echarts/components'
// 标签自动布局、全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features'
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import './styles/element-variables.scss'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import i18n from './i18n/i18n'

// 全局方法
import ext from '@/utils/ext'
Vue.prototype.ext = ext

Vue.use(Viewer)
Viewer.setDefaults({
  // 需要配置的属性 注意属性并没有引号
  title: false,
  toolbar: true,
  zIndex: 99999,
  scalable: false
})

Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(ElementUI)
Vue.use(quillEditor)
Vue.use(VueStorage, {
  namespace: 'pro__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local' // storage name session, local, memory
})
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})
// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  LegendComponent,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  DataZoomComponent,
  LineChart,
  PictorialBarChart
])
Vue.prototype.$echarts = echarts
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
